import React from 'react';
import LinkWrapper from '../../../util/LinkWrapper';

import './scss/SiteLogo.scss';

const SiteLogo = (props) => {
	const wData = props.data || {},
		{ data = {}, meta: meta = {} } = wData,
		{ logo: logoUrl = '', action = {}, alt="logo" } = data,
		{ primary = {} } = action,
		{ logo: logoMeta = {} } = meta;

	return (<>
		{logoMeta.canShow && <LinkWrapper action={primary} className="site-logo">
			<img src={logoUrl} className={`app-logo${logoMeta.size === 'lg' ? ' logo-lrg': ''}`} alt={alt} title={alt} />
		</LinkWrapper>}
	</>
	)
}

export default SiteLogo
